export default __webpack_public_path__ + "static/BrewSoftwareLogo300-e2074b1e77dd24e559228421347b6add.png";